import { AgGridReact } from 'ag-grid-react'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { schemedelete, schemelist } from '../../../../services/master';
import Swal from 'sweetalert2';

export const ListScheme = () => {
  const navigate = useNavigate();
  const [filterProduct, setFilterProduct] = useState([]);
  const role = localStorage.getItem("Role");
  const columnDefs = [
    ...(role == 1
      ? [
        {
          headerName: "Actions",
          field: "id",
          width: 150,
          sortable: true,
          resizable: true,
          filter: false,
          floatingFilter: false,
          cellStyle: { textAlign: "left" },
          cellRenderer: function (params) {
            return (
              <div className="text-center">
                <a
                  onClick={() =>
                    navigate(`/master/schemedetail/${params.value}`)
                  }
                  className="btn-sm btn-info me-2"
                >
                  <i className="fa fa-edit"></i>
                </a>
                <a
                  onClick={() => handleSwitch(params.value)}
                  className="btn-sm btn-danger"
                >
                  <i className="fa fa-trash"></i>
                </a>
              </div>
            );
          },
        },
      ]
      : []),

    {
      headerName: "Scheme ID",
      field: "scheme_id",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Total Amount",
      field: "total_amount",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Interest",
      field: "interest",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Dues",
      field: "no_of_dues",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  useEffect(() => {
    funlist();
  }, []);

  function handleSwitch(lid) {
    Swal.fire({
      text: "Are you sure want to Delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ac0404",
      cancelButtonColor: "#6259ca",
      confirmButtonText: "Delete",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        const temp = new FormData();
        temp.append("id", lid);
        temp.append("status", 0);
        schemedelete(temp).then((response) => {
          if (response.status === true) {
            funlist();
          } else {
            Swal.fire({
              text: response.message,
              icon: "warning",
              allowOutsideClick: false,
            });
          }
        });
      }
    });

  }

  function funlist() {
    schemelist().then((response) => {
      if (response.status === true) {
        setFilterProduct(response.data);
      }
    })
  }
  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Scheme</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Master</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Scheme
          </li>
        </ol>
      </div>

      <div className="content-body">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className='d-flex justify-content-end mb-3'>
                <a className='btn btn-success' onClick={() => navigate('/master/addscheme')}>Add Scheme</a>
              </div>
              <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                  columnDefs={columnDefs}
                  rowData={filterProduct}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={["asc", "desc"]}
                  suppressDragLeaveHidesColumns={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
